// Mock data for BOLDIGITAL landing page

export const heroData = {
  eyebrow: "BOLDIGITAL · WEBFEJLESZTÉS · WEBAPP · AI MEGOLDÁSOK",
  titleLine1: "Weboldal, webes applikáció",
  titleLine2: "és AI megoldások",
  // Legacy single-string title kept for fallback / SEO
  title: "Weboldal, webes applikáció és AI megoldások",
  subtitle: "Modern weboldalak, egyedi webes alkalmazások és AI-megoldások egy kézből – konverzióra és üzleti eredményekre tervezve.",
  ctaPrimary: "Ingyenes konzultáció",
  ctaSecondary: "Ajánlatkérés",
  heroImage: "https://static.prod-images.emergentagent.com/jobs/486c5f92-7cd7-4488-a4dc-4b78b8257eda/images/30c953bf47d63fbd34e6ac62e829ca2d76a4a24292bd7ff50649fc98675c3acf.png",
  heroVisualAlt: "https://static.prod-images.emergentagent.com/jobs/486c5f92-7cd7-4488-a4dc-4b78b8257eda/images/56bdff271241b66bbda3cb92f74214dcd84b100ed61b88e447261cd793adbed9.png",
  trustItems: ["Modern fejlesztés", "Automatizálás", "Üzleti fókusz"]
};

export const servicesData = [
  {
    id: 1,
    title: "Weboldal tervezés és fejlesztés",
    description: "Modern, mobilbarát weboldalak és landing page-ek, amelyek valódi ügyfeleket hoznak. Konverzióra optimalizált dizájn, gyors betöltés, SEO-barát felépítés.",
    features: [
      "Egyedi dizájn és fejlesztés",
      "Mobilra optimalizált megjelenés",
      "SEO alapok beépítve",
      "Gyors betöltési idő"
    ]
  },
  {
    id: 2,
    title: "Webes applikáció fejlesztés",
    description: "Egyedi rendszerek, admin felületek és online megoldások vállalkozásoknak.",
    features: [
      "Egyedi backend és adatbázis",
      "Admin felület és jogosultságkezelés",
      "API integrációk",
      "Skálázható architektúra"
    ]
  },
  {
    id: 3,
    title: "AI megoldások",
    description: "AI-alapú megoldások – chatbotok, dokumentum-feldolgozás, döntéstámogatás és AI-stratégia.",
    features: [
      "Chatbotok és AI-asszisztensek ügyfélszolgálatra vagy belső használatra",
      "Dokumentum-feldolgozás automatizálása: számlák, szerződések, beadványok",
      "Döntéstámogató rendszerek adatokból, előrejelzésekből és ajánlásokból",
      "AI-stratégia és koncepcióalkotás"
    ]
  }
];

export const whyUsData = [
  {
    id: 1,
    title: "Üzleti fókusz",
    description: "Nem csak fejlesztünk – mérhető üzleti eredményekre tervezünk, a konkrét célokhoz igazítva."
  },
  {
    id: 2,
    title: "Modern digitális megoldások",
    description: "Naprakész technológiák: modern weboldal, webes applikáció és AI alapok egy stackben."
  },
  {
    id: 3,
    title: "Automatizálás és skálázhatóság",
    description: "Skálázható rendszerek és automatizált folyamatok, amelyek a növekedéssel együtt nőnek."
  },
  {
    id: 4,
    title: "Egyedi fejlesztés",
    description: "Sablonok helyett az igényekre szabott megoldások, hosszú távra építve."
  }
];

export const processData = [
  {
    step: 1,
    title: "Ingyenes konzultáció",
    description: "Megbeszéljük az igényeidet és céljaidat."
  },
  {
    step: 2,
    title: "Stratégia és koncepció",
    description: "Személyre szabott megoldási tervet készítünk."
  },
  {
    step: 3,
    title: "Dizájn és fejlesztés",
    description: "Elkészítjük a weboldalt, applikációt vagy AI-modult."
  },
  {
    step: 4,
    title: "Tesztelés és indítás",
    description: "Minden részletet ellenőrzünk az indulás előtt."
  },
  {
    step: 5,
    title: "Üzemeltetés és továbbfejlesztés",
    description: "Folyamatos támogatás, mérés és skálázás."
  }
];

export const packagesData = [
  {
    id: 1,
    name: "Weboldal",
    description: "Modern, konverzióra optimalizált weboldal",
    features: [
      "Egyedi dizájn és fejlesztés",
      "Mobilra optimalizált megjelenés",
      "SEO alapok beépítve",
      "Tartalomkezelő rendszer (CMS)",
      "Indítás utáni támogatás"
    ],
    highlight: false
  },
  {
    id: 2,
    name: "Webes Applikáció",
    description: "Egyedi rendszerek és belső eszközök",
    features: [
      "Egyedi backend és adatbázis",
      "Admin felület és jogosultságkezelés",
      "API integrációk külső rendszerekhez",
      "Skálázható, modern architektúra",
      "Karbantartás és továbbfejlesztés"
    ],
    highlight: true
  },
  {
    id: 3,
    name: "AI / Automatizálás",
    description: "AI-megoldások és folyamat-automatizálás",
    features: [
      "AI chatbot vagy AI-asszisztens",
      "Dokumentum-feldolgozás (OCR, kategorizálás)",
      "Folyamat-automatizálás (workflow)",
      "Döntéstámogató rendszerek",
      "AI-stratégia és koncepcióalkotás"
    ],
    highlight: false
  }
];

export const contactData = {
  phone: "+36 30 318 3155",
  email: "info@boldigital.hu",
  formFields: [
    { name: "name", label: "Név", type: "text", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    { name: "phone", label: "Telefonszám", type: "tel", required: false },
    { name: "message", label: "Üzenet", type: "textarea", required: true }
  ]
};

export const navLinks = [
  { id: "services", label: "Szolgáltatások" },
  { id: "why-us", label: "Miért mi?" },
  { id: "process", label: "Folyamat" },
  { id: "packages", label: "Csomagok" },
  { id: "contact", label: "Kapcsolat" }
];
